import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from '@/assets/styles/_export.scss';
import '@mdi/font/css/materialdesignicons.css';

import csv from '@/assets/icons/csv.svg?inline';
import wms from '@/assets/icons/wms.svg?inline';
import label from '@/assets/icons/label.svg?inline';
import labelActive from '@/assets/icons/labelActive.svg?inline';
import qgis from '@/assets/icons/qgis.svg?inline';
import superadmin from '@/assets/icons/superadmin.svg?inline';
import point from '@/assets/icons/point.svg?inline';
import calendar from '@/assets/icons/calendar.svg?inline';
import filter from '@/assets/icons/filter.svg?inline';
import filteractive from '@/assets/icons/filteractive.svg?inline';
import selection from '@/assets/icons/selection.svg?inline';
import selectionActive from '@/assets/icons/selectionActive.svg?inline';
import unselection from '@/assets/icons/unselection.svg?inline';
import unfilter from '@/assets/icons/unfilter.svg?inline';
import pdf_file_icon from '@/assets/icons/pdf_file_icon.svg?inline';
import image from '@/assets/icons/image.svg?inline';
import wifi from '@/assets/icons/wifi.svg?inline';
import coordinates from '@/assets/icons/coordinates.svg?inline';
import parcelReport from '@/assets/icons/parcel_report.svg?inline';
import reverseGeocoder from '@/assets/icons/reverseGeocoder.svg?inline';
import quickprint from '@/assets/icons/quickPrint.svg?inline';
import createTask from '@/assets/icons/createTask.svg?inline';
import createKomadresOrder from '@/assets/icons/createKomadresOrder.svg?inline';
import spatialBookmarks from '@/assets/icons/spatialBookmarks.svg?inline';
import paintbrush from '@/assets/icons/paintbrush.svg?inline';
import multiparcel from '@/assets/icons/multiparcel.svg?inline';
import mapArrow from '@/assets/icons/map-arrow.svg?inline';
import tableLargeCopy from '@/assets/icons/tableLargeCopy.svg?inline';
import cropSquare from '@/assets/icons/cropSquare.svg?inline';
import scl from '@/assets/icons/scl.svg?inline';
import layersSearch from '@/assets/icons/layersSearch.svg?inline';
import roadCopy from '@/assets/icons/roadCopy.svg?inline';
import multiPolygon from '@/assets/icons/multipolygon.svg?inline';
import uldk from '@/assets/icons/uldk.svg?inline';
import investmentAreaSearch from '@/assets/icons/investmentAreaSearch.svg?inline';
import googleMaps from '@/assets/icons/googleMaps.svg?inline';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      calendar: {
        component: calendar,
      },
      wms: {
        component: wms,
      },
      csv: {
        component: csv,
      },
      label: {
        component: label,
      },
      labelActive: {
        component: labelActive,
      },
      qgis: {
        component: qgis,
      },
      superadmin: {
        component: superadmin,
      },
      point: {
        component: point,
      },
      filter: {
        component: filter,
      },
      filteractive: {
        component: filteractive,
      },
      selection: {
        component: selection,
      },
      unselection: {
        component: unselection,
      },
      unfilter: {
        component: unfilter,
      },
      selectionActive: {
        component: selectionActive,
      },
      pdf_file_icon: {
        component: pdf_file_icon,
      },
      image: {
        component: image,
      },
      wifi: {
        component: wifi,
      },
      parcelReport: {
        component: parcelReport,
      },
      coordinates: {
        component: coordinates,
      },
      reverseGeocoder: {
        component: reverseGeocoder,
      },
      quickprint: {
        component: quickprint,
      },
      createTask: {
        component: createTask,
      },
      createKomadresOrder: {
        component: createKomadresOrder,
      },
      spatialBookmarks: {
        component: spatialBookmarks,
      },
      paintbrush: {
        component: paintbrush,
      },
      mapArrow: {
        component: mapArrow,
      },
      tableLargeCopy: {
        component: tableLargeCopy,
      },
      multiparcel: {
        component: multiparcel,
      },
      cropSquare: {
        component: cropSquare,
      },
      scl: {
        component: scl,
      },
      layersSearch: {
        component: layersSearch,
      },
      roadCopy: {
        component: roadCopy,
      },
      multiPolygon: {
        component: multiPolygon,
      },
      uldk: {
        component: uldk,
      },
      investmentAreaSearch: {
        component: investmentAreaSearch,
      },
      googleMaps: {
        component: googleMaps,
      },
    },
  },
  lang: {
    current: process.env.VUE_APP_I18N_LOCALE,
  },
  theme: {
    themes: {
      light: colors,
    },
  },
});
